import { Link, useLocation } from "react-router-dom";
import Logo from "../images/logo/logo.png";
import DropdownNotification from "./DropdownNotification";
import DropdownUser from "./DropdownUser";
import { useEffect, useState } from "react";
import HeaderHome from "./Headerhome";
import HeaderAllPage from "./HeaderAllPage";
import CeoInbox from "./CeoInbox";
import { ThemeSelector } from "../components/Theme/Themecontext";
import { useTranslation } from "react-i18next";
import HeaderChat from "./HeaderChat";

const Header = ({ setHeaderOpen , count }) => {

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const location = useLocation();
  const { t, i18n } = useTranslation();

  const isDashboard = location.pathname === "/home";
  setTimeout(() => {
    setIsRefresh(false);
  }, 5000);

  const [isRefresh, setIsRefresh] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };




  return (
    <>
      {/* desktop */}
      <header className=" hidden lg:block relative top-0 w-full border-b-2">
        <div
          className={`flex w-full h-[90px] flex-grow items-center justify-between py-4 px-4 md:px-6 2xl:px-11 ${i18n.language === "ar"
            ? "flex-row-reverse justify-end"
            : "flex-row justify-start"
            }`}
        >
          <div className="lg:flex hidden ">
            <CeoInbox isRefresh={isRefresh} />
          </div>



          <div
            className={`flex  items-center gap-3 sm:gap-7 ${i18n.language === "ar"
              ? "flex-row-reverse justify-end"
              : "flex-row justify-start"
              }`}
          >
            {/* <div className={`flex gap-1 text-[#787878] items-center  `}>
              <button onClick={() => changeLanguage("en")}>En</button> |{" "}
              <button onClick={() => changeLanguage("ar")}>Ar</button>
            </div> */}
            <Link to="/home/notification" className="relative inline-block">

              <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M2.45058 11.8602L3.09311 12.247L3.09479 12.2442L2.45058 11.8602ZM1.30058 13.7702L0.658051 13.3833L0.657938 13.3835L1.30058 13.7702ZM2.38058 16.7002L2.14013 17.4106L2.14291 17.4115L2.38058 16.7002ZM15.6506 16.7002L15.4152 15.9881L15.4129 15.9888L15.6506 16.7002ZM16.7306 13.7702L17.3737 13.3843L17.3731 13.3833L16.7306 13.7702ZM15.5806 11.8602L14.9308 12.235L14.9381 12.247L15.5806 11.8602ZM10.6608 1.91971C11.0586 2.0352 11.4747 1.80635 11.5902 1.40856C11.7057 1.01077 11.4768 0.59468 11.079 0.479193L10.6608 1.91971ZM9.90992 0.999453L9.81689 1.74367L9.81967 1.744L9.90992 0.999453ZM6.96057 0.479266C6.56282 0.59489 6.33411 1.01106 6.44973 1.40881C6.56536 1.80656 6.98153 2.03526 7.37928 1.91964L6.96057 0.479266ZM9.02058 0.160156C5.29636 0.160156 2.27058 3.18594 2.27058 6.91016H3.77058C3.77058 4.01437 6.12479 1.66016 9.02058 1.66016V0.160156ZM2.27058 6.91016V9.80016H3.77058V6.91016H2.27058ZM2.27058 9.80016C2.27058 10.0148 2.222 10.3288 2.12915 10.6633C2.03637 10.9975 1.91607 11.2921 1.80637 11.4761L3.09479 12.2442C3.29508 11.9082 3.45978 11.4778 3.5745 11.0645C3.68915 10.6515 3.77058 10.1955 3.77058 9.80016H2.27058ZM1.80805 11.4733L0.658051 13.3833L1.9431 14.157L3.0931 12.247L1.80805 11.4733ZM0.657938 13.3835C0.1969 14.1497 0.100699 15.0094 0.383495 15.7731C0.665963 16.5359 1.29772 17.1254 2.14013 17.4106L2.62102 15.9897C2.16343 15.8349 1.90019 15.5494 1.79016 15.2522C1.68045 14.956 1.69425 14.5706 1.94321 14.1568L0.657938 13.3835ZM2.14291 17.4115C6.60716 18.903 11.424 18.903 15.8882 17.4115L15.4129 15.9888C11.2572 17.3773 6.77399 17.3773 2.61824 15.9888L2.14291 17.4115ZM15.886 17.4123C17.555 16.8605 18.2794 14.8939 17.3737 13.3843L16.0875 14.156C16.5017 14.8464 16.1661 15.7398 15.4152 15.9881L15.886 17.4123ZM17.3731 13.3833L16.2231 11.4733L14.9381 12.247L16.088 14.157L17.3731 13.3833ZM16.2302 11.4854C16.1223 11.2983 16.0033 11.0008 15.9114 10.6655C15.8192 10.3295 15.7706 10.015 15.7706 9.80016H14.2706C14.2706 10.1953 14.3519 10.6508 14.4648 11.0623C14.5779 11.4745 14.7388 11.902 14.9309 12.2349L16.2302 11.4854ZM15.7706 9.80016V6.91016H14.2706V9.80016H15.7706ZM15.7706 6.91016C15.7706 3.19594 12.7348 0.160156 9.02058 0.160156V1.66016C11.9064 1.66016 14.2706 4.02437 14.2706 6.91016H15.7706ZM11.079 0.479193C10.7364 0.379731 10.3764 0.300508 10.0002 0.254903L9.81967 1.744C10.1034 1.7784 10.3834 1.83918 10.6608 1.91971L11.079 0.479193ZM10.0029 0.255245C8.94736 0.123296 7.92412 0.199162 6.96057 0.479266L7.37928 1.91964C8.13572 1.69974 8.95249 1.63561 9.8169 1.74366L10.0029 0.255245ZM11.2695 17.0605C11.2695 18.2963 10.2553 19.3105 9.01953 19.3105V20.8105C11.0837 20.8105 12.7695 19.1248 12.7695 17.0605H11.2695ZM9.01953 19.3105C8.40701 19.3105 7.83539 19.0557 7.42986 18.6502L6.3692 19.7109C7.04368 20.3854 7.99205 20.8105 9.01953 20.8105V19.3105ZM7.42986 18.6502C7.02434 18.2447 6.76953 17.6731 6.76953 17.0605H5.26953C5.26953 18.088 5.69473 19.0364 6.3692 19.7109L7.42986 18.6502Z" fill="#787878" /> </svg>

             
            </Link>

            <div className="absolute left-3 lg:relative">
              <Link to="/home/userprofile">
                {" "}
                <DropdownUser />{" "}
              </Link>
            </div>
          </div>
        </div>
      </header>
      {/* mobile header  */}

      {(location.pathname === "/home" ||
        location.pathname === "/home/quickall") && (
          <HeaderHome setHeaderOpen={setHeaderOpen} />
        )}

      {location.pathname === "/home/chat/newchat/chatpage" && (
        <HeaderChat setHeaderOpen={setHeaderOpen} />
      )}

      {!isDashboard &&
        location.pathname !== "/home" &&
        location.pathname !== "/home/quickall" &&
        !location.pathname.startsWith("/home/chat/newchat/chatpage") && (
          <HeaderAllPage currentPath={location.pathname} />
        )}
    </>
  );
};

export default Header;
